module.exports = __webpack_public_path__ + "static/front-app-39d81bcb30633dc3f4ae520d5975739b.svg";